import RouteView from '@/router/RouteView.vue';
import Statistical from './index.vue';
import StatisticalClass from './StatisticalClass.vue';

export default [
  {
    path: '/statistical',
    name: 'Statistical3',
    component: RouteView,
    redirect: '/statistical/list',
    meta: {
      title: '上课统计',
    },
    children: [
      {
        path: '/statistical/list',
        name: 'StatisticalList',
        component: Statistical,
        meta: {
          title: '统计列表',
        },
      },
      {
        path: '/statistical/class/:id',
        name: 'StatisticalClass3',
        component: StatisticalClass,
        meta: {
          title: '上课统计',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/Statistical/router.js